import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useSpaceTags } from '@tribeplatform/react-sdk/hooks';
import { simplifyPaginatedResult } from '@tribeplatform/react-sdk/utils';
import { SearchableSelect } from '@tribeplatform/react-ui-kit/SearchableSelect';
import { useDebounce } from '../common/hooks/useDebounce';
import { T } from '../i18n';
export const SpaceTagSelector = ({ spaceId, onSelect, selectedTag }) => {
    const [query, setQuery] = useState('');
    const debouncedQuery = useDebounce(query, 300);
    const { data, isFetching } = useSpaceTags({
        variables: {
            spaceId,
            limit: 10,
            query: debouncedQuery,
        },
        useInfiniteQueryOptions: {
            enabled: !!spaceId,
        },
    });
    const { nodes: spaceTags } = simplifyPaginatedResult(data);
    return (_jsxs(SearchableSelect, { value: selectedTag, options: spaceTags, onChange: onSelect, onInputChange: setQuery, children: [_jsx(SearchableSelect.Button, { placeholder: "Select tag", children: selectedTag === null || selectedTag === void 0 ? void 0 : selectedTag.title }, void 0), _jsxs(SearchableSelect.Items, { children: [spaceTags.map((tag, index) => (_jsx(SearchableSelect.Item, { value: tag, index: index, children: tag.title }, tag.id))), isFetching && (_jsx(SearchableSelect.ItemsEmpty, { children: _jsx(T, { id: "Generics.LoadingDotDotDot", defaultMessage: "Loading..." }, void 0) }, void 0)), !isFetching && query && spaceTags.length === 0 && (_jsx(SearchableSelect.ItemsEmpty, { children: _jsx(T, { id: "Generics.NoResults", defaultMessage: "No results" }, void 0) }, void 0))] }, void 0)] }, void 0));
};
//# sourceMappingURL=SpaceTagSelector.js.map